import { render } from "./PressReleaseForm.vue?vue&type=template&id=5d24a3a6"
import script from "./PressReleaseForm.vue?vue&type=script&lang=js"
export * from "./PressReleaseForm.vue?vue&type=script&lang=js"

import "./PressReleaseForm.vue?vue&type=style&index=0&id=5d24a3a6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__